import React from 'react';
import clsx from 'clsx';

const TimelineItem = ({ lead, headline, index }) => {
    const isAbove = index % 2 === 0;

    return (
        <div className="relative flex flex-col items-center w-[70px] min-w-[70px] font-lato">
            {/* Dot */}
            <div className="w-4 h-4 bg-[#483889] rounded-full z-10 absolute top-1/2 -translate-y-[40%] border-[3px] border-white" />

            {/* Dot content*/}
            <div className="w-4 h-4 bg-[#483889] rounded-full z-10 absolute  -translate-y-[40%] border-[3px] border-white" style={isAbove ? {top:"5px"}:{bottom:"-8px"}}/>
            {/* Vertical line */}
            <div
                className="absolute w-px border-l border-dotted border-[#48388980] border-2 h-1/2"
                style={isAbove ? { bottom: '50%' } : { top: '50%' }}
            />

            {/* Card */}
            <div
                className={`px-3 rounded-md text-sm text-gray-700 w-[300px] absolute left-9 ${isAbove ? 'top-0' : 'bottom-0'
                    }`}
            >
                <p className="!font-lato mb-1 text-[20px] font-bold" style={{color:"#5A27E7"}}>{headline}</p>
                <p className='text-lg'>{lead}</p>
            </div>
        </div>
    );
};

export default TimelineItem;
